import { processCrudConfig } from '@/config/objects/processes';
import { CrudListView, PageContainer } from '@startupquickstart/frontend';

/**
 * Processes list page. Displays all documented processes in a filterable,
 * searchable table with create / edit / delete actions.
 */
export function ProcessesPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Processes', current: true },
  ];

  return (
    <PageContainer>
      <CrudListView
        config={processCrudConfig}
        baseUrl="/processes"
        breadcrumbs={breadcrumbs}
      />
    </PageContainer>
  );
}
